export const alertingConstants = {
  TELEMETRY_ALERT_DATA: "GET_TELEMETRY_ALERT_DATA"
};



// WEBPACK FOOTER //
// ./src/_constants/alerting.constants.js